/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import "./UserInformation.scss";
import DeleteDialog from "../SharedComponents/DeleteDialog";
import SuccessDialog from "../SharedComponents/SuccessDialog";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { deleteTenantUser, getUserLogo, getUserListBasedOnForgeCustomerId } from "../../store/User/user-actions";
import Loader from "../Loader/Loader";
import { IErrorProps, WrapperUserPermissions } from "../../models";

import BreadCrumbsComponent from "../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../SharedComponents/Title/Title";
import { Button, Card, CardContent } from "@forge/common";
import React from "react";
import defaultLogo from "../../images/LogoShow.png";
import UploadProfilePic from "../../utils/upload-profile-pic/UploadProfilePic";
import { Grid, Tooltip } from "@mui/material";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import updateErrorList from "../../utils/methods/updateErrorList";
import { setErrorPopupsusingErrorCode } from "../TenantUser/setErrorPopupsusingErrorCode";
import GetTokenValues from "../../utils/methods/GetTokenValues";
import { isDeleteButtonEnabled } from "../../utils/methods/deleteDisableonPersona";
import { isEditButtonDisabled } from "../../utils/methods/editDisableonPersona";
import OrgHierarchyTooltip from "../TenantUser/OrgHierarchyTooltip";
import Organization from "../../models/apiModels/Organization";
import OrganizationHDTOKey from "../../models/apiModels/OrganizationHDTOKey";
import { useTranslation } from '@scuf/localization';
import { localeKeyMap } from '../../localization/keys';

const USER_CRUMB_ID = "user";

function UserInformationPage(props: any) {
  const [t] = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [userLogo, setUserLogo] = useState<string>();
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state.organisation.hierarchicalOrganizationwKey
  );
  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////
  // CID 3180022

  if (!location) {
    setErrorListGlobal((prevState) =>
      updateErrorList({ data: t(localeKeyMap.noInformation) }, [...prevState])
    );
  }
  const pathName: string = location?.pathname;
  const userId = location?.state?.UserInfo?.userId;
  const firstName = location?.state?.UserInfo?.firstName;
  const lastName = location?.state?.UserInfo?.lastName;
  const emailId = location?.state?.UserInfo?.emailId;
  const assignedRoles: string[] = location?.state?.UserInfo?.roles
    ? location?.state?.UserInfo?.roles?.map((x: { name: any }) => x.name)
    : [];
  const IP = location?.state?.UserInfo?.customerId;
  const sso_enabled = location?.state?.UserInfo?.sso_enabled;
  const forgeCustomerId = location?.state?.CustomerId;
  // new fields
  const phoneNumber = location?.state?.UserInfo?.phoneNumber ?? "";

  // Get parent organization Names

  const parentOrganisations: Array<Organization> =
    location?.state?.UserInfo?.organization ?? [];
  const identityProvider = location?.state?.CustomerDetails?.tenantName ?? "";
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };
  // end new fields

  const backButtonHandler = () => {
    navigate(-1);
  };

  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );
  const userPersonaLoggedin = userPermissions.user_persona;

  const basicInfo = [
    { label: t(localeKeyMap.firstName), value: firstName },
    { label: t(localeKeyMap.lastName), value: lastName },
    { label: t(localeKeyMap.emailId), value: emailId },
    { label: t(localeKeyMap.phoneNumber), value: phoneNumber },
  ];

  const otherInfo = [
    { label: t(localeKeyMap.assignedRole), value: assignedRoles?.join(", ") ?? "" },
  ];
  // To keep the layout intact
  if (sso_enabled) {
    otherInfo.push({ label: t(localeKeyMap.identityProvider), value: IP });
    otherInfo.push({ label: "", value: "" });
  } else {
    otherInfo.push({ label: "", value: "" });
    otherInfo.push({ label: "", value: "" });
  }

  const isSelfUser = userId === tokenInfo?.userId;

  // APi call in the component
  // istanbul ignore next
  useEffect(() => {
    setIsLoading(true);
    dispatch(getUserLogo({ customerId: forgeCustomerId, userId }))
      .then((response: any) => {
        response.status === 204
          ? setUserLogo(defaultLogo)
          : setUserLogo(response.data || response.payload.data);
      })
      .catch((error) => {
        setUserLogo(defaultLogo);
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  function handleDelete() {
    if (userPermissions?.can_delete_user) {
      setUserSelected({
        userIds: [userId],
        customerId: forgeCustomerId,
      });

      setOpenDeleteDialog(true);
    } else {
      //for error list
      // istanbul ignore next
      setForBiddenError(
        403,
        t(localeKeyMap.noPrivilegesToDeleteUsers)
      );
    }
  }
  function handleEdit() {
    // istanbul ignore next
    if (userPermissions?.can_update_user) {
      const userDetailsToEdit = {
        CustomerId: location?.state?.CustomerId,
        UserInfo: location?.state?.UserInfo,
      };
      navigate(`/tenant/user/edit`, {
        state: { userDetailsToEdit },
      });
    } else {
      //for error list
      // istanbul ignore next
      setForBiddenError(403, t(localeKeyMap.noPrivilegesToEditUsers));
    }
  }
  //on click of stoast for delete
  // istanbul ignore next
  const handleClose = () => {
    setUserSelected({
      customerId: "",
      userIds: [""],
    });
    setOpenDeleteDialog(false);
  };
  //on click of stoast for delete
  // istanbul ignore next

  const handleDeleteConfirmation = () => {
    setOpenDeleteDialog(false);
    dispatch(deleteTenantUser(userSelected))
      .unwrap()
      .then(() => {
        setUserSelected({
          userIds: [""],
          customerId: "",
        });
        dispatch(getUserListBasedOnForgeCustomerId(forgeCustomerId));
        setSuccessDialogOpen(true);
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      });
  };
  //on close of successDialogOpen
  // istanbul ignore nexts

  const handleSuccesssConfirmationClose = () => {
    setSuccessDialogOpen(false);
    navigate(-1);
  };
  const [userSelected, setUserSelected] = useState<{
    customerId: string;
    userIds: Array<string>;
  }>({
    customerId: "",
    userIds: [""],
  });
  const [crumbs, setCrumbs] = useState([
    {
      id: USER_CRUMB_ID,
      label: t(localeKeyMap.user),
    },
    {
      id: "UserInformationPage",
      label: firstName + " " + lastName,
    },
  ]);

  const componentPage = () => {
    if (pathName.includes("organization")) {
      return "organizationUserList";
    } else if (pathName.includes("tenant")) {
      return "tenantUserPage";
    } else {
      return "";
    }
  };

  const handleCrumbClick = (crumb: { id: string; href?: string }) => {
    if (crumb.id === USER_CRUMB_ID) {
      if (pathName.includes("organization")) {
        navigate("/organization-user-list");
      } else {
        navigate("/tenant/user");
      }
    }
  };

  const isEditBtnEnabled = (cellvalues: any) => {
    const cellValModified = {
      row: cellvalues?.UserInfo,
    };
    const disabledVal = isEditButtonDisabled({
      component: componentPage(),
      isLoggedInUser: isSelfUser,
      userPersonaLoggedin: userPersonaLoggedin,
      cellValues: cellValModified,
    });
    return disabledVal;
  };

  const isDeleteBtnEnable = (cellvalues: any) => {
    const cellValModified = {
      row: cellvalues?.UserInfo,
    };
    const disabledVal = isDeleteButtonEnabled({
      component: componentPage(),
      isLoggedInUser: isSelfUser,
      userPersonaLoggedin: userPersonaLoggedin,
      cellValues: cellValModified,
    });
    return disabledVal;
  };

  return (
    <div className="userinfo">
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={backButtonHandler}
        onCrumbClick={handleCrumbClick}
      />
      <Title
        title={t(localeKeyMap.userInformation)}
        className="p-t15 p-b15"
        buttonRequired={false}
      />
      <Card>
        <CardContent className="card-content p-15">
          <div className="p-15 color-bg-img">
            <UploadProfilePic
              isUploadDisabled={true}
              profilePic={
                !userLogo ? defaultLogo : `data:image/jpeg;base64,${userLogo}`
              }
            />
          </div>

          <div className="info-container p-10">
            <h5 className="info-title">{t(localeKeyMap.basicInformation)}</h5>
            <div className="info-row p-b15">
              {basicInfo.map((info, index) => {
                return (
                  <div className="info-col">
                    <label className="info-heading p-10">{info.label}</label>
                    <Tooltip arrow title={info.value}>
                      <label className="info-content p-10">{info.value}</label>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
            <h5 className="info-title">{t(localeKeyMap.otherInformation)}</h5>

            <div className="info-row">
              <div className="info-col">
                <label className="info-heading p-10">
                  {t(localeKeyMap.assignedOrganization)}
                </label>
                <label className="info-heading p-10">
                  <Tooltip
                    // placement="right-start"
                    arrow
                    title={
                      parentOrganisations &&
                      parentOrganisations?.map((el: Organization) => {
                        return (
                          <Tooltip
                            placement="right-start"
                            arrow
                            title={
                              <OrgHierarchyTooltip
                                selectedKeyLsit={[el.name]}
                                hierarchicalOrganizationwKey={
                                  hierarchicalOrganizationwKey
                                }
                              />
                            }
                          >
                            <div style={{ color: "#0071B3" }}>{el.name}</div>
                          </Tooltip>
                        );
                      })
                    }
                    className="info-content"
                  >
                    {parentOrganisations && parentOrganisations.length == 1 ? (
                      <div> {parentOrganisations[0]?.name}</div>
                    ) : (
                      <div className="info-content">
                        {parentOrganisations && parentOrganisations[0]?.name},{" "}
                        <span style={{ color: "#0071B3" }}>
                          +{parentOrganisations?.length - 1}
                        </span>
                      </div>
                    )}
                  </Tooltip>
                </label>

                {/* <label className="info-content p-10">sdj</label> */}
              </div>
              {otherInfo.map((info, index) => {
                return (
                  <div className="info-col">
                    <label className="info-heading p-10">{info.label}</label>
                    <Tooltip arrow title={info.value}>
                      <label className="info-content p-10">{info.value}</label>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          </div>
        </CardContent>
      </Card>
      {/* Footer starts */}
      <Card className="footer">
        <Button
          size="regular"
          variant="quiet-primary"
          className="cursor-pointer"
          onClick={() => handleDelete()}
          disabled={!isDeleteBtnEnable(location?.state)}
        >
          {t(localeKeyMap.delete)}
        </Button>

        <Button
          size="regular"
          variant="primary"
          className="cursor-pointer"
          onClick={handleEdit}
          disabled={!isEditBtnEnabled(location?.state)}
        >
          {t(localeKeyMap.edit)}
        </Button>
      </Card>
      {/* Footer end */}
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />}
      {openDeleteDialog && (
        <DeleteDialog
          open={openDeleteDialog}
          title={t(localeKeyMap.delete)}
          handleClose={handleClose}
          DeleteConfirmationMessage={t(localeKeyMap.deleteSingleUser)}
          subTitle={t(localeKeyMap.pleaseConfirm)}
          handleDeleteConfirmation={handleDeleteConfirmation}
        />
      )}

      {successDialogOpen && (
        <SuccessDialog
          open={successDialogOpen}
          title={t(localeKeyMap.successfullyDeleted)}
          SuccessConfirmationMessage={t(localeKeyMap.userDeletedSuccessfully)}
          handleClose={handleSuccesssConfirmationClose}
        />
      )}
    </div>
  );

  //for error list
  // istanbul ignore next

  function setForBiddenError(errorCode: number, message: string) {
    const error: IErrorProps = {
      errorCode: errorCode,
      errorMessage: message,
    };

    setErrorListGlobal((prevState) => updateErrorList(error, [...prevState]));
  }
}

export default UserInformationPage;
